import { ActionIcon, Paper, Stack, Text, Tooltip } from '@mantine/core';

import Button from '@/components/content/button/Button';

import { useConfirmation } from '@/hooks/useConfirmation';

import ExternalLinkIcon from '@/assets/icons/content/external-link.svg';

import classes from './SourceLinkButton.module.css';

const LABEL = 'Go to the source';

interface SourceLinkButtonProps {
  url: string | null;
  iconOnly?: boolean;
}

const SourceLinkButton = ({ url, iconOnly }: SourceLinkButtonProps) => {
  const { getConfirmation } = useConfirmation();

  if (!url) return null;

  const openSource = async () => {
    const confirmed = await getConfirmation({
      title: 'You are leaving Mercury',
      text: (
        <Stack gap={12} w="100%">
          <Text>
            This is an external source that QuoIntelligence does not control. Visiting it is under
            your own responsibility.
          </Text>

          <Paper withBorder p={10} radius="sm" bg="var(--quo-grey-15)">
            <Text size="sm" lineClamp={2} title={url} className={classes.url}>
              {url}
            </Text>
          </Paper>
        </Stack>
      ),
      confirmText: 'Continue to the source',
      confirmColor: 'var(--quo-pink)',
    });

    if (confirmed) {
      window.open(url, '_blank', 'noreferrer');
    }
  };

  if (iconOnly) {
    return (
      <Tooltip label={LABEL}>
        <ActionIcon aria-label={LABEL} onClick={openSource} variant="subtle" size={35}>
          <ExternalLinkIcon />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Button variant="outline" onClick={openSource} rightSection={<ExternalLinkIcon />}>
      {LABEL}
    </Button>
  );
};

export default SourceLinkButton;
